import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import KineticHeading from "@/components/KineticHeading";
import BookCard from "@/components/BookCard";
import Reveal from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Books() {
  const [books, setBooks] = useState([]);
  const [activeMood, setActiveMood] = useState("All");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    axios.get(`${API}/books`)
      .then((response) => { setBooks(response.data); setStatus("ready"); })
      .catch(() => setStatus("error"));
  }, []);

  const moods = useMemo(() => ["All", ...new Set(books.map((book) => book.mood))], [books]);
  const visibleBooks = activeMood === "All" ? books : books.filter((book) => book.mood === activeMood);

  return (
    <div className="px-5 pb-28 pt-36 md:px-8 md:pt-44" data-testid="books-page">
      <section className="mx-auto max-w-7xl">
        <Reveal><p className="text-xs uppercase tracking-[0.35em] text-cocoa/50" data-testid="books-eyebrow">The little shelf</p></Reveal>
        <div className="mt-6 grid gap-10 lg:grid-cols-[1fr_0.55fr] lg:items-end">
          <KineticHeading testId="books-kinetic-heading" lines={["Browse by", "mood, longing,", "and lamplight."]} className="font-display text-6xl font-light leading-[0.88] tracking-[-0.04em] md:text-8xl" />
          <Reveal delay={0.25}>
            <p className="text-base leading-8 text-cocoa/65 md:text-lg" data-testid="books-intro-text">A petite, carefully dressed collection of fictional favorites from the Morgan Ella universe.</p>
          </Reveal>
        </div>
        <Reveal delay={0.35} className="mt-12">
          <div className="flex flex-wrap gap-3" data-testid="book-mood-filters">
            {moods.map((mood) => (
              <button key={mood} type="button" data-testid={`book-filter-${mood.toLowerCase().replaceAll(" ", "-")}`} onClick={() => setActiveMood(mood)} className={`rounded-full border px-5 py-2 text-sm transition-colors duration-300 ${activeMood === mood ? "border-cocoa bg-cocoa text-white" : "border-cocoa/15 bg-white/60 text-cocoa/65 hover:border-cocoa/40"}`}>
                {mood}
              </button>
            ))}
          </div>
        </Reveal>
      </section>

      <section className="mx-auto mt-16 max-w-7xl" data-testid="book-collection-section">
        {status === "loading" && <p className="rounded-[2rem] bg-petal/50 p-10 text-center" data-testid="books-loading-message">Arranging the shelf...</p>}
        {status === "error" && <p className="rounded-[2rem] bg-petal p-10 text-center" data-testid="books-error-message">The shelf could not be loaded. Please try again.</p>}
        {status === "ready" && (
          <div className="grid gap-7 md:grid-cols-2 xl:grid-cols-3" data-testid="book-collection-grid">
            {visibleBooks.map((book, index) => <BookCard key={book.id} book={book} index={index} />)}
          </div>
        )}
      </section>
    </div>
  );
}
